export default "__VITE_ASSET__71afcb6b__"